// src/components/auth/PublicRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../firebase/useAuth';
import Spinner from '../common/Spinner';
import MainNavbar from '../MainNavbar';
import MainFooter from '../MainFooter';

const PublicRoute = ({ children }) => {
  const { userId, userLoading } = useAuth();

  if (userLoading) {
    // Show a full page layout with the spinner to prevent layout shifts
    return (
      <div className="flex flex-col min-h-screen bg-background-primary">
        <MainNavbar />
        <main className="flex-grow flex items-center justify-center">
          <Spinner />
        </main>
        <MainFooter />
      </div>
    );
  }

  if (userId) {
    // If the user is logged in, redirect them away to the dashboard.
    return <Navigate to="/dashboard" replace />;
  }

  // If loading is done and there's no user, render the page.
  return children;
};

export default PublicRoute;
